<!-- 顶部导航组件 -->
<template>
	<div class="header-container">
		<div class="header-top">
			<div class="top-box">
				<div class="box-img">
					<img src="../../assets/img/logo_nav.png" width="100%" height="100%">
				</div>
			</div>
		</div>
		<el-menu :default-active="defaultMenu" @select="select($event)" router class="header-el-menu" mode="horizontal" background-color="#0286c7" text-color="#fff" active-text-color="#fff">
			<el-menu-item index="1" route="/home">首页</el-menu-item>
			<el-menu-item index="2" route="/list?title=商会时事&type=57">商会时事</el-menu-item>
			<el-submenu index="3">
				<template slot="title">商会党建</template>
				<el-submenu index="3-1">
					<template slot="title">
						<el-menu-item index="3-1" route="/list?title=组织机构&type=59">组织机构</el-menu-item>
					</template>
					<el-menu-item index="3-1-1" route="/list?title=联合会党委&type=65">联合会党委</el-menu-item>
					<el-menu-item index="3-1-2" route="/list?title=外埠商会支部&type=66">外埠商会支部</el-menu-item>
				</el-submenu>
				<el-menu-item index="3-2" route="/list?title=专题专栏&type=60">专题专栏</el-menu-item>
				<el-menu-item index="3-3" route="/list?title=支部风采&type=61">支部风采</el-menu-item>
				<el-menu-item index="3-4" route="/list?title=队伍建设&type=62">队伍建设</el-menu-item>
				<el-menu-item index="3-5" route="/list?title=党建动态&type=63">党建动态</el-menu-item>
				<el-menu-item index="3-5" route="/list?title=党规党章&type=64">党规党章</el-menu-item>
			</el-submenu>
			<el-submenu index="4">
				<template slot="title">新闻动态</template>
				<el-submenu index="4-1">
					<template slot="title">
						<el-menu-item index="4-1" route="/list?title=国内新闻&type=20">国内新闻</el-menu-item>
					</template>
					<el-menu-item index="4-1-1" route="/list?title=中央要闻&type=42">中央要闻</el-menu-item>
					<el-menu-item index="4-1-2" route="/list?title=省内要闻&type=43">省内要闻</el-menu-item>
				</el-submenu>
				<el-menu-item index="4-2" route="/list?title=国外新闻&type=21">国外新闻</el-menu-item>
				<el-menu-item index="4-3" route="/list?title=外埠新闻&type=29">外埠新闻</el-menu-item>
			</el-submenu>
			<el-submenu index="5">
				<template slot="title">招商引资</template>
				<el-menu-item index="5-1" route="/list?title=招商信息发布&type=32">招商信息发布</el-menu-item>
				<el-menu-item index="5-2" route="/list?title=招商政策解读&type=33">招商政策解读</el-menu-item>
				<el-menu-item index="5-3" route="/list?title=外埠招商动态&type=34">域外招商动态</el-menu-item>
				<el-menu-item index="5-4" route="/list?title=招商成果展示&type=35">招商成果展示</el-menu-item>
			</el-submenu>
			<el-submenu index="6">
				<template slot="title">商会服务</template>
				<el-submenu index="6-1">
					<template slot="title">法律服务</template>
					<el-menu-item index="6-1-1" route="/list?title=法律法规&type=71">法律法规</el-menu-item>
					<el-menu-item index="6-1-2" route="/list?title=服务机构&type=72">服务机构</el-menu-item>
					<el-menu-item index="6-1-4" route="/list?title=法律信息&type=89">法律信息</el-menu-item>
					<el-menu-item index="6-1-3" route="/form-ask?title=问题咨询">问题咨询</el-menu-item>
				</el-submenu>
				<el-submenu index="6-2">
					<template slot="title">金融服务</template>
					<el-menu-item index="6-2-1" route="/list?title=法律法规&type=73">法律法规</el-menu-item>
					<el-menu-item index="6-2-2" route="/list?title=服务信息&type=74">服务信息</el-menu-item>
					<el-menu-item index="6-2-4" route="/list?title=金融机构&type=90">金融机构</el-menu-item>
					<el-menu-item index="6-2-3" route="/form-ask?title=问题咨询">问题咨询</el-menu-item>
				</el-submenu>
				<el-submenu index="6-3">
					<template slot="title">劳务服务</template>
					<el-menu-item index="6-3-1" route="/list?title=法律法规&type=75">法律法规</el-menu-item>
					<el-menu-item index="6-3-2" route="/list?title=劳务信息&type=76">劳务信息</el-menu-item>
					<el-menu-item index="6-3-4" route="/list?title=劳务机构&type=91">劳务机构</el-menu-item>
					<el-menu-item index="6-3-3" route="/form-ask?title=问题咨询">问题咨询</el-menu-item>
				</el-submenu>
				<el-submenu index="6-4">
					<template slot="title">健康服务</template>
					<el-menu-item index="6-4-1" route="/list?title=法律法规&type=77">法律法规</el-menu-item>
					<el-menu-item index="6-4-2" route="/list?title=服务机构&type=78">健康机构</el-menu-item>
					<el-menu-item index="6-4-3" route="/list?title=健康宣传&type=79">健康宣传</el-menu-item>
					<el-menu-item index="6-4-4" route="/list?title=健康信息&type=92">健康信息</el-menu-item>
				</el-submenu>
				<el-menu-item index="6-5" route="/email?title=会长信箱&ArticleID=36&TenantId=229">会长信箱</el-menu-item>
			</el-submenu>
			<el-submenu index="7">
				<template slot="title">会员之家</template>
				<el-menu-item index="7-1" route="/list?title=明星企业家&type=52">明星企业</el-menu-item></el-menu-item>
				<el-menu-item index="7-2" route="/list?title=优质产品&type=53">优质产品</el-menu-item>
				<el-menu-item index="7-3" route="/list?title=会员风采&type=54">会员风采</el-menu-item>
				<el-menu-item index="7-4" route="/form-join?title=入会申请">入会申请</el-menu-item>
			</el-submenu>
			<el-submenu index="8">
				<template slot="title">友好往来</template>
				<el-menu-item index="8-1" route="/list?title=友好商会&type=68">友好商会</el-menu-item>
				<el-menu-item index="8-2" route="/list?title=交流互访&type=69">交流互访</el-menu-item>
				<el-menu-item index="8-3" route="/list?title=他山之石&type=70">他山之石</el-menu-item>
			</el-submenu>
		</el-menu>
	</div>
</template>

<script>
	export default {
		name: "nav_header",
		data() {
			return {
				defaultMenu: "1"
			}
		},
		mounted: function() {
			this.defaultMenu = localStorage.getItem("currentMenu")
		},
		watch: {
			$route(to, from) {
				if (to.query.index) {
					this.defaultMenu = to.query.index
				} else {
					this.defaultMenu = localStorage.getItem("currentMenu")
				}
				// debugger
			}
		},
		methods: {
			select: function(val) {
				localStorage.setItem("currentMenu", val)
			}
		},
	}
</script>

<style scoped>
	.header-container {
		background: #0286c7;
	}

	.header-container .header-top {
		height: 160px;
		min-width: 1200px;
		background-image: url(../../assets/img/bg_header.jpg);
		background-size: 100% 100%;
	}

	.header-top .top-box {
		width: 1200px;
		margin: auto;
	}

	.header-top .top-box .box-img {
		width: 195px;
		height: 160px;
		padding: 10px 0;
	}

	.header-el-menu {
		width: 1200px;
		height: 50px;
		margin: auto;
		display: flex;
		text-align: center;
		justify-content: space-between;
	}

	.el-menu-item {
		text-align: center;
	}

</style>



// WEBPACK FOOTER //
// src/components/nav-header/index.vue